var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2411_43207)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.25 9.5C17.25 9.30109 17.171 9.11032 17.0303 8.96967C16.8897 8.82902 16.6989 8.75 16.5 8.75H14.25V6.5C14.25 6.30109 14.171 6.11032 14.0303 5.96967C13.8897 5.82902 13.6989 5.75 13.5 5.75H10.5C10.3011 5.75 10.1103 5.82902 9.96967 5.96967C9.82902 6.11032 9.75 6.30109 9.75 6.5V8.75H7.5C7.30109 8.75 7.11032 8.82902 6.96967 8.96967C6.82902 9.11032 6.75 9.30109 6.75 9.5V12.5C6.75 12.6989 6.82902 12.8897 6.96967 13.0303C7.11032 13.171 7.30109 13.25 7.5 13.25H9.75V15.5C9.75 15.6989 9.82902 15.8897 9.96967 16.0303C10.1103 16.171 10.3011 16.25 10.5 16.25H13.5C13.6989 16.25 13.8897 16.171 14.0303 16.0303C14.171 15.8897 14.25 15.6989 14.25 15.5V13.25H16.5C16.6989 13.25 16.8897 13.171 17.0303 13.0303C17.171 12.8897 17.25 12.6989 17.25 12.5V9.5Z",
  fill: "#2260E5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.25004 4.42393V12.0379C2.25006 14.4446 2.97936 16.7947 4.3418 18.7786C5.70424 20.7624 7.63586 22.2869 9.88204 23.1509L10.923 23.5509C11.6163 23.8176 12.3838 23.8176 13.077 23.5509L14.118 23.1509C16.3642 22.2869 18.2958 20.7624 19.6583 18.7786C21.0207 16.7947 21.75 14.4446 21.75 12.0379V4.42393C21.7521 4.13739 21.6712 3.85637 21.5172 3.61472C21.3632 3.37307 21.1426 3.1811 20.882 3.06193C18.0819 1.83972 15.0552 1.22259 12 1.25093C8.94489 1.22259 5.9182 1.83972 3.11804 3.06193C2.85744 3.1811 2.63685 3.37307 2.48285 3.61472C2.32885 3.85637 2.248 4.13739 2.25004 4.42393V4.42393Z",
  stroke: "#2260E5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2411_43207"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(0 0.5)"
})));

function SvgHealth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.b0f568d03bc1deef8d8ea2186043ae60.svg";
export { ForwardRef as ReactComponent };